export enum MaxWEnum {
    MaxWSm = 'max-w-sm',
    MaxWMd = 'max-w-md',
    MaxWLg = 'max-w-lg',
    MaxWXl = 'max-w-xl',
    None = '',
}